<div [ngClass]="{
    'container-large': isLarge(),
    'container-medium': isMedium(),
    'container-small': isSmall(),
    'container-xsmall': isXSmall()
  }">
    <app-shout-outs></app-shout-outs>
</div>
<app-bottom-menu></app-bottom-menu>
